import { useState, useEffect } from 'react';
import { FaWhatsapp } from "react-icons/fa";
import {
  DEFAULT_WHATSAPP_PHONE_NUMBER,
  getCurrentClientConfig,
} from "config/clientConfig";

export default function WhatsAppButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [scrollTimeout, setScrollTimeout] = useState(null);
  const clientConfig = getCurrentClientConfig();
  const whatsappConfig = clientConfig?.checkout?.whatsapp || {};
  const normalizedTenantPhone = String(
    whatsappConfig.phoneNumber || ""
  ).replace(/\D/g, "");
  const normalizedDefaultPhone = String(
    DEFAULT_WHATSAPP_PHONE_NUMBER || ""
  ).replace(/\D/g, "");
  const normalizedPhoneNumber = normalizedTenantPhone || normalizedDefaultPhone;
  const displayInitials = whatsappConfig.displayInitials || "";
  const displayName = whatsappConfig.displayName || "";
  const displayPhoneText = whatsappConfig.displayPhoneText || "";

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(true);

      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }

      const timeout = setTimeout(() => {
        setIsVisible(false);
      }, 2000);

      setScrollTimeout(timeout);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
    };
  }, [scrollTimeout]);

  if (!normalizedPhoneNumber) {
    return null;
  }

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${normalizedPhoneNumber}`, '_blank');
  };

  return (
    <>
      {/* WhatsApp Button */}
      <div
        className={`fixed bottom-2 right-6 z-50 transition-all duration-300 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <button
          onClick={handleWhatsAppClick}
          className="flex items-center gap-3 bg-white rounded-full shadow-lg hover:shadow-xl transition-shadow px-4 py-3 border border-gray-200"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center text-sm font-semibold text-gray-700">
              {displayInitials}
            </div>
            <div className="text-left">
              <div className="text-sm font-semibold text-gray-800">{displayName}</div>
              <div className="text-xs text-gray-500">{displayPhoneText}</div>
            </div>
          </div>
          <div className="bg-green-500 rounded-full p-2 ml-2 text-white text-2xl">
            <FaWhatsapp />
          </div>
        </button>
      </div>
    </>
  );
}
